import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import Select from "react-select";
import Form from "react-bootstrap/Form";

import NotificationWindow from "../../../../GeneralComponents/NotificationWindow/NotificationWindow";

import { fetchWithToken } from "../../../../../interceptors/fetchInterceptor";
import { MAIN_URL, PORT_FOR_INTEGRATION, PORT_FOR_REPORT } from "../../../../../constants/constants";

import { customErrorStyles, customStyles } from "./styleData";

import styles from "./SearchBlock.module.css";

function SearchBlock({
  fields,
  setOptionsForField,
  urlForReport,
  setExcelFile,
  setPDFFile,
  setDocsFile,
  getOptionsForField,
  setLoader,
  setDataFotShortReport,
  createAccess = true,
}) {
  const [directoryLoad, setDirectoryLoad] = useState(false);
  const [showNotificationWindow, setShowNotificationWindow] = useState(false);
  const [messageNotificationWindow, setMessageNotificationWindow] = useState("");
  const [data, setData] = useState({});
  const [options, setOptions] = useState(Object.values(fields));
  const [errors, setErrors] = useState({});
  const [dataRangeError, setDataRangeError] = useState("");
  const [description, setDescription] = useState("");
  const errorsFields = Object.values(fields)
    .filter((el) => el.required)
    .map((el) => el.key);
  const [saveKey, setSaveKey] = useState(false);
  const date1Ref = useRef();
  const date2Ref = useRef();
  const sectionRef = useRef();
  const oblastRef = useRef();
  const quarterRef = useRef();
  const yearRef = useRef();
  const typeGraphRef = useRef();
  const periodGraphRef = useRef();
  const gimsRef = useRef();
  const report = useRef();

  const optionsOblast = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer.allOblast.map((el) => {
      return { ...el, key: "oblast" };
    });
  });

  let optionsSection = useSelector((state) => state.dictionaryReducer.gimsSections);

  function setRef(field) {
    switch (field.key) {
      case "date1":
        return date1Ref;
      case "date2":
        return date2Ref;
      case "section":
        return sectionRef;
      case "oblast":
        return oblastRef;
      case "year":
        return yearRef;
      case "quarter":
        return quarterRef;
      case "graph":
        return typeGraphRef;
      case "periodGraph":
        return periodGraphRef;
      case "gims":
        return gimsRef;
      case "report":
        return report;
      default:
        return null;
    }
  }

  const handleErrors = () => {
    let newErrors = {};
    errorsFields.forEach((elem) => {
      if (!data[elem] || data[elem] === "" || data[elem].length < 1) {
        newErrors[elem] = "Заполните поле";
      }
    });
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return true;
    } else {
      setErrors({});
      return false;
    }
  };
  const handleGetReport = (e) => {
    if (!handleErrors() && compareDate()) {
      let queryString = "";
      if (window.location.href.includes("reports/graphs")) {
        queryString = data.graph.map((el) => "graph=" + encodeURIComponent(el.value)).join("&");
        if (data.month1 && data.month2) {
          queryString += `&month1=${data.month1}&month2=${data.month2}`;
          urlForReport = urlForReport[1];
        } else if (data.periodGraph === 3) {
          urlForReport = urlForReport[2];
        } else {
          urlForReport = urlForReport[0];
        }
      } else {
        queryString = Object.keys(data)
          .map((key) =>
            key === "report"
              ? key +
                "=" +
                encodeURIComponent(data[key][0]) +
                "&" +
                "reportNum" +
                "=" +
                encodeURIComponent(data[key][1])
              : key + "=" + encodeURIComponent(data[key]),
          )
          .join("&");
      }

      setLoader(true);
      const getFile = async () => {
        const response = await fetchWithToken(
          `${
            MAIN_URL +
            (window.location.href.includes("reports/paidservicesreport")
              ? PORT_FOR_INTEGRATION
              : PORT_FOR_REPORT) +
            urlForReport
          }?${queryString}`,
        );

        if (response.ok) {
          setLoader(false);

          const formData = await response.formData();
          const filePdf = formData.get("pdf");
          const fileExcel = formData.get("excel");
          const docsFile = formData.get("docx");
          setPDFFile(filePdf);
          setExcelFile(fileExcel);
          setDocsFile(docsFile);
        } else if (response.status === 404) {
          const responseData = await response.text();
          setLoader(false);
          setMessageNotificationWindow(responseData);
          setShowNotificationWindow(!showNotificationWindow);
        } else {
          console.error("Ошибка загрузки файла:");
        }
      };

      const getData = async () => {
        const response = await fetchWithToken(
          `${
            MAIN_URL +
            (window.location.href.includes("reports/paidservicesreport")
              ? PORT_FOR_INTEGRATION
              : PORT_FOR_REPORT) +
            urlForReport
          }?${queryString}`,
        );

        if (response.ok) {
          setLoader(false);
          const responseData = await response.json();
          setDataFotShortReport({
            data: responseData,
            date1: data.date1,
            date2: data.date2,
          });
        } else {
          console.error("Ошибка загрузки файла:");
        }
      };

      if (window.location.href.includes("reports/shortreport")) {
        getData();
      } else {
        getFile();
      }
    } else {
      setSaveKey(true);
    }
  };

  const compareDate = () => {
    if (data.date1 && data.date2) {
      switch (true) {
        case new Date(data.date1) > new Date(data.date2):
          setDataRangeError(
            'Дата, установленная в "Период отчета c" не может быть больше даты, установленной в "Период отчета по".',
          );
          return false;
        case new Date(data.date1) > new Date() || new Date(data.date2) > new Date():
          setDataRangeError("Установленные даты не могут быть позже текущей даты");
          return false;
        default:
          setDataRangeError("");
          return true;
      }
    }
    if (data.month1 && data.month2) {
      switch (true) {
        case data.month1 > data.month2:
          setDataRangeError(
            'Месяц, установленный в "Месяц c" не может быть больше месяца, установленный в "Месяц по".',
          );
          return false;
        case new Date(data.month1) > new Date().getMonth() + 1 ||
          new Date(data.month2) > new Date().getMonth() + 1:
          setDataRangeError("Установленные месяцы не могут быть позже текущего");
          return false;
        default:
          setDataRangeError("");
          return true;
      }
    }
    if (data.year) {
      switch (true) {
        case data.year > new Date().getFullYear():
          setDataRangeError("Год отчёта не может быть больше текущего");
          return false;
        case Number(data.year) === new Date().getFullYear():
          const currentMonth = new Date().getMonth() + 1;
          const currentQuarter = Math.ceil(currentMonth / 3);
          if (data.quarter === 5) {
            setDataRangeError("Отчёт за год можно составить только по прошедшим годам");
            return false;
          }
          if (data.quarter >= currentQuarter) {
            setDataRangeError("Отчёт можно составить только по прошедшим кварталам текущего года");
            return false;
          }
        default:
          setDataRangeError("");
          return true;
      }
    }
    return true;
  };

  const handleChangeData = (e) => {
    if (e) {
      switch (true) {
        case Object.keys(e).includes("target"): {
          data[`${e.target.id}`] = e.target.value;
          const newData = { ...data };
          setData(newData);
          break;
        }
        case Array.isArray(e): {
          data["graph"] = e;
          const newData = { ...data };
          setData(newData);
          break;
        }
        case Object.keys(e).includes("key"): {
          data[`${e.key}`] = e.value;
          const newData = { ...data };
          if (e.key === "gims") {
            if (e.value === 1) {
              setOptionsForField(false, "section");
            }
            if (e.value === 2) {
              setOptionsForField(true, "section");
            }
          }
          if (e.key === "section") {
            setOptionsForField(true, "oblast");
          }
          if (e.key === "oblast") {
            setOptionsForField(true, "section");
          }
          if (e.key === "periodGraph") {
            setOptionsForField(e.value, "periodGraph");
            delete newData.month1;
            delete newData.month2;
            delete newData.graph;
            typeGraphRef.current.clearValue();
            setPDFFile("");
            setDocsFile("");
          }
          if (e.key === "report") {
            setDescription(e.description);
            setOptionsForField(e.value, "report");
            delete newData?.section;
            delete newData?.oblast;
            setDocsFile("");
            setExcelFile("");
            setPDFFile("");
          }
          setData(newData);
          break;
        }
        default:
          break;
      }
      if (saveKey) handleErrors();
    }
  };
  const handleClearData = () => {
    if (window.location.href.includes("reports/graphs")) {
      typeGraphRef.current.clearValue();
      periodGraphRef.current.clearValue();
      setOptionsForField(0, "periodGraph");
      setOptions(Object.values(getOptionsForField()));

      setPDFFile("");
      setDocsFile("");
      setExcelFile("");
      setErrors({});
      setDataRangeError("");
      setSaveKey(false);
      setData({});
      return;
    }

    if (!window.location.href.includes("reports/quarterlyreport")) {
      date1Ref.current.value = "";
      date2Ref.current.value = "";
    } else {
      yearRef.current.value = "";
      quarterRef.current.clearValue();
    }
    if (window.location.href.includes("reports/shortreport")) {
      date1Ref.current.value = "";
      date2Ref.current.value = "";
      setDataFotShortReport([]);
    } else {
      sectionRef.current?.clearValue();
      oblastRef.current?.clearValue();
    }
    if (window.location.href.includes("reports/training-report")) {
      gimsRef.current.clearValue();
    }
    if (window.location.href.includes("reports/paidservicesreport")) {
      report.current.clearValue();
      setOptionsForField([], "report");
    }

    setOptionsForField(false, "oblast");
    setOptionsForField(false, "section");
    setOptions(Object.values(getOptionsForField()));
    setLoader(false);
    setPDFFile("");
    setDocsFile("");
    setExcelFile("");
    setErrors({});
    setDataRangeError("");
    setSaveKey(false);
    setData({});
  };

  useEffect(() => {
    if (!window.location.href.includes("reports/graphs")) {
      setOptionsForField(optionsSection, "optionsForSection");
    }
    handleClearData();
    setOptions(Object.values(getOptionsForField()));
  }, []);

  useEffect(() => {
    if (directoryLoad) {
      setOptionsForField(optionsOblast, "firstInit");
      setOptions(Object.values(getOptionsForField()));
    }
  }, [directoryLoad]);

  useEffect(() => {
    if (Boolean(optionsOblast.length) && !directoryLoad) {
      setDirectoryLoad(true);
    }
  }, [optionsOblast]);

  return (
    <>
      <Form className={styles["form_inputs"]}>
        {!!dataRangeError && <div className={styles["range_block"]}>{dataRangeError}</div>}
        <div className={styles["form-container"]}>
          {options.map((field) => {
            if (field.type === "number" && !field.hidden)
              return (
                <Form.Group className={styles["input_element"]}>
                  <label className={styles["label"]}>
                    {field.label}
                    {field.required && <span className={styles["red_dot"]}>*</span>}
                  </label>
                  <input
                    id={field.key}
                    ref={setRef(field)}
                    disabled={field.disabled}
                    value={data[`${field.key}`]}
                    placeholder="Введите"
                    onChange={(e) => {
                      handleChangeData(e);
                    }}
                    type={field.type}
                    min={1900} // Минимальное значение года
                    max={2200} // Максимальное значение года
                    className={`${styles["form-input"]} ${errors[field.key] && styles["red_border"]}`}
                  />
                  {errors[field.key] && <div className={styles["feedback"]}>{errors[`${field.key}`]}</div>}
                </Form.Group>
              );
            if (field.type === "date" && !field.hidden)
              return (
                <Form.Group className={styles["input_element"]}>
                  <label className={styles["label"]}>
                    {field.label}
                    {field.required && <span className={styles["red_dot"]}>*</span>}
                  </label>
                  <input
                    id={field.key}
                    ref={setRef(field)}
                    disabled={field.disabled}
                    value={data[`${field.key}`]}
                    placeholder="Введите"
                    onChange={(e) => {
                      handleChangeData(e);
                    }}
                    type={field.type}
                    className={`${styles["form-input"]} ${errors[field.key] && styles["red_border"]}`}
                    isInvalid={!!errors[`${field.key}`]}
                  />
                  {errors[field.key] && <div className={styles["feedback"]}>{errors[`${field.key}`]}</div>}
                </Form.Group>
              );
            if (field.type === "selectSearch" && !field.hidden)
              return (
                <Form.Group className={styles["input_element"]}>
                  <label className={styles["label"]}>
                    {field.label}
                    {field.required && <span className={styles["red_dot"]}>*</span>}
                  </label>
                  <Select
                    noOptionsMessage={() => "Нет данных"}
                    ref={setRef(field)}
                    isMulti={field.multi}
                    onChange={(e) => {
                      handleChangeData(e);
                    }}
                    isSearchable={field.search}
                    isDisabled={field.disabled}
                    placeholder={field.placeholder ? field.placeholder : "Выберите"}
                    options={field.options}
                    className={styles["max_width_select"]}
                    styles={!!errors[field.key] ? customErrorStyles : customStyles}
                    isHidden={field.hidden}
                  />
                  {!!data.report && field.description && (
                    <div className={styles["description"]}>{description}</div>
                  )}
                  {errors[field.key] && <div className={styles["feedback"]}>{errors[`${field.key}`]}</div>}
                </Form.Group>
              );
          })}
        </div>
        <div className={styles["buttons-container"]}>
          {createAccess && (
            <div
              onClick={(e) => handleGetReport(e)}
              className={styles["add-btn"]}>
              Создать
            </div>
          )}
          <div
            onClick={() => handleClearData()}
            className={styles["close-btn"]}>
            Очистить
          </div>
        </div>
      </Form>
      <NotificationWindow
        isError={showNotificationWindow}
        show={showNotificationWindow}
        setShow={setShowNotificationWindow}
        headerText={"Уведомление"}
        messageText={messageNotificationWindow}
      />
    </>
  );
}

export default SearchBlock;
